module.exports = __webpack_public_path__ + "static/media/pittohio.2fc8cb6a.svg";